var relatedSwatch = {

  elements: {},

  init: async function() {
    if (!(await this.customerCanOrderSwatch())) {
      return;
    }
   
    if(!this.getElements()) {
      return;
    }

    var selectedVariant = this.getSelectedVariant();

    if(!selectedVariant) {
      selectedVariant = this.getDefaultVariant();
    }

    if(!selectedVariant) {
      return;
    }

    this.renderSwatchButton(selectedVariant);
    this.setSwatch(selectedVariant);
    this.setEvents();
  },

  customerCanOrderSwatch: async function() {
    const customer = await creodeAjaxAPI.getData('customer');

    if (typeof customer.tags == 'undefined') {
      return false;
    }

    return customer.tags.includes('swatches'); 
  },

  getElements: function() {
    this.elements.addToCartButton = jQuery('body.template--product .button--addToCart');
    this.elements.formSwatchButton = jQuery('#order-swatch-button');
    this.elements.formSwatch = jQuery('body.related-swatch__form');
    this.elements.formSwatchInput = jQuery('#related-swatch__input');
    if(!this.elements.addToCartButton.length) {
        return false;
    }

    return true;
  },

  renderSwatchButton: function(variant) {
    var _self = this;

    jQuery('.button--addRelatedSwatch').remove();

    if(!variant.related_swatch) {
        return;
    }

    this.elements.button = jQuery('<button type="button" class="button button--addRelatedSwatch button--secondary__ghost">Order Swatch</button>');
    this.elements.button.insertAfter(this.elements.addToCartButton);
    this.elements.button.on(
      "click",
      function(){
        _self.elements.formSwatchButton.get(0).dispatchEvent(new Event("click"));
      }
    );
  },

  getSelectedVariant: function() {
    var productIds = Object.keys(BoosterTheme.swatches.current);

    if(!productIds.length) {
      return null;
    }

    var variants = BoosterTheme.swatches.getVariants(productIds[0]);

    if(typeof variants[BoosterTheme.swatches.findVariant(productIds[0])] == 'undefined') {
      return null;
    }

    return variants[BoosterTheme.swatches.findVariant(productIds[0])];
  },

  getDefaultVariant: function() {
    let productInfo = JSON.parse(jQuery('[data-product-info').text());

    if ( typeof productInfo.default_variant == 'undefined' ) {
      return null;
    }

    return productInfo.default_variant;
  },

  setSwatch: function(variant) {
    if(!variant.related_swatch) {
      return;
    }

    this.elements.formSwatchInput.val(variant.related_swatch.id);
  },

  setEvents: function() {
    var _self = this;

    BoosterTheme.swatches.events.on(
      'booster:variant:select',
      function() {
        var selectedVariant = _self.getSelectedVariant();
        _self.renderSwatchButton(selectedVariant);
        _self.setSwatch(selectedVariant);
      }
    );
  }
};

async function initRelatedSwatch() {
  /**
   * Wait for dependencies to be available
   */
  await new Promise(
    (resolve) => {
      // Poll every 50ms for dependency availability
      const interval = setInterval(
        () => {
          // Check if the required API is available
          if (typeof creodeAjaxAPI == 'undefined') {
            return; // Continue polling
          }

          // Check if the required BoosterTheme is available
          if (typeof BoosterTheme == 'undefined') {
            return; // Continue polling
          }

          // Dependency found - stop polling and resolve
          clearInterval(interval);
          resolve();
        },
        50 // Check every 50 milliseconds
      );
    }
  );

  // Initialize the related swatch functionality
  relatedSwatch.init();
}

jQuery(document).ready(
    function() {
        initRelatedSwatch();
    }
);
